import * as React from 'react';
import { connect } from 'react-redux';

import type { SignatureFieldVM } from '@acceligentllc/shared/utils/fieldReport';
import { formatDate, abbreviateTimeZone } from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';
import { TimeSheetSignatureStatus } from '@acceligentllc/shared/enums/timeSheetSignatureStatus';

import type { RootState } from 'af-reducers';

import Image from 'af-components/Image';

import SignatureStatusLabel from '../../../../../Shared/SignatureStatusLabel';

interface OwnProps {
	value: Nullable<SignatureFieldVM>;
	name: string;
}

interface StateProps {
	timezone: Nullable<string>;
}

type Props = React.PropsWithChildren<OwnProps> & StateProps;

const SignatureStatus: React.FC<Props> = (props) => {
	const { value, name, children, timezone } = props;

	return (
		<>
			{name}
			<div className="report-block__signature-field">
				{!!value
					? <>
						<div>
							<SignatureStatusLabel
								className="report-block__signature-field__signature-label"
								status={TimeSheetSignatureStatus.SIGNED}
							/>
							<div className="report-block__signature-field__signature-name">
								by {value.name} {formatDate(value.signedAt, TimeFormat.FULL_DATE, TimeFormat.ISO_DATETIME, timezone ?? 'UTC')}, <b>{abbreviateTimeZone(timezone ?? 'UTC', 'z (Z)')}</b>
							</div>
						</div>
						<Image className="report-block__signature-field__signature-image" src={value.imageUrl} />
						{children}
					</>
					: <div>
						<SignatureStatusLabel
							className="report-block__signature-field__signature-label"
							status={TimeSheetSignatureStatus.UNSIGNED}
						/>
						N/A
					</div>
				}
			</div>
		</>
	);
};

function mapStateToProps(state: RootState): StateProps {
	const { fieldReport } = state.fieldReport;
	return { timezone: fieldReport?.timezone ?? null };
}

export default connect(mapStateToProps)(SignatureStatus);
